import React from 'react';
import { FormGenerator } from '@hwm/ui-lib';
import { BaseExportType, GeneralPreferencesModel } from '@shared/models';
import { useFormikContext } from 'formik';
import { generalPreferencesFieldsConfiguration } from './GeneralPreferences.utils';

interface GeneralPreferencesProps {
  conditions: string[];
  exports: BaseExportType[];
}

export const GeneralPreferences: React.FC<GeneralPreferencesProps> = ({ conditions, exports }) => {
  const { values, errors, touched, handleBlur, handleChange, setFieldValue, validateField } =
    useFormikContext<GeneralPreferencesModel>();

  return (
    <div>
      <FormGenerator
        fieldsConfiguration={generalPreferencesFieldsConfiguration(conditions, exports)}
        values={values}
        errors={errors}
        touched={touched}
        handleChange={handleChange}
        handleBlur={handleBlur}
        setFieldValue={setFieldValue}
        validateField={validateField}
        formDisabled={false}
        newEditableLook
      />
    </div>
  );
};
